module.exports = __webpack_public_path__ + "static/bslGov_about-201baa331b9d122e8f832bdf722f5720.png";